import { useState } from 'react';
import { useSeoMeta } from '@unhead/react';
import { Layout } from '@/components/Layout';
import { UploadModal } from '@/components/UploadModal';
import { VideoCard, VideoCardSkeleton } from '@/components/VideoCard';
import { useVideoFeed } from '@/hooks/useVideoFeed';

export default function TrendingPage() {
  const [uploadOpen, setUploadOpen] = useState(false);
  const { data: videos, isLoading } = useVideoFeed();

  useSeoMeta({
    title: 'Trending – Goblinbox',
    description: 'Watch trending videos on Goblinbox, the decentralized Nostr video platform.',
  });

  const trending = videos ? [...videos].sort((a, b) => b.created_at - a.created_at) : undefined;

  return (
    <Layout onUploadClick={() => setUploadOpen(true)}>
      <div className="px-4 sm:px-6 py-6" style={{ maxWidth: 1400, margin: '0 auto' }}>
        <div className="mb-6">
          <h1 className="flex items-center gap-2 text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ color: 'var(--gb-accent)' }}>
              <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" />
            </svg>
            Trending
          </h1>
          <p className="text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>
            Most recent videos on the Nostr network
          </p>
        </div>

        {isLoading ? (
          <div className="video-grid">
            {Array.from({ length: 8 }).map((_, i) => <VideoCardSkeleton key={i} />)}
          </div>
        ) : trending && trending.length > 0 ? (
          <div className="video-grid">
            {trending.map(event => <VideoCard key={event.id} event={event} />)}
          </div>
        ) : (
          <div className="rounded-xl py-16 px-8 text-center" style={{ border: '2px dashed var(--gb-border)' }}>
            <div className="text-5xl mb-4">📈</div>
            <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
              No trending videos found. Try connecting to more relays in settings.
            </p>
          </div>
        )}
      </div>
      <UploadModal open={uploadOpen} onClose={() => setUploadOpen(false)} />
    </Layout>
  );
}
